module.exports = new __parcel__URL__("platform.f28329f1.svg").toString();